"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
var _a;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppNear = void 0;
var types_1 = require("../../../../../common/types");
var bs58_1 = __importDefault(require("bs58"));
var isomorphic_ws_1 = __importDefault(require("isomorphic-ws"));
var near_api_js_1 = require("near-api-js");
var utils_1 = require("near-api-js/lib/utils");
var AppMessages_1 = require("../types/AppMessages");
var ServerMessage_1 = require("../types/ServerMessage");
var utils_2 = require("../utils");
var isomorphic_localstorage_1 = __importDefault(require("isomorphic-localstorage"));
var localStorage = (0, isomorphic_localstorage_1.default)('./.localstorage');
var sessionIdKey = 'nightly-id-near';
var AppNear = /*#__PURE__*/_createClass(function AppNear(ws, timeout) {
  var _this = this;
  _classCallCheck(this, AppNear);
  this.events = {};
  this.sessionId = '';
  this.send = function (message) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this2 = this;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var id = (0, utils_2.getRandomId)();
              var request = JSON.stringify(Object.assign(Object.assign({}, message), {
                id: id
              }));
              // Set up the timeout
              var timer = setTimeout(function () {
                reject(new Error("Connection timed out after ".concat(_this2.timeout, " ms")));
              }, _this2.timeout);
              _this2.events[id] = function (response) {
                clearTimeout(timer);
                if (response.type === ServerMessage_1.ServerMessageTypes.Error) {
                  reject(response.msg);
                } else {
                  resolve(response);
                }
              };
              _this2.ws.send(request);
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  };
  this.signTransaction = function (transaction) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var request, response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            request = {
              transaction: Buffer.from(transaction.encode()).toString('hex'),
              network: types_1.NETWORK.NEAR,
              type: AppMessages_1.AppMessageTypes.SignTransaction
            };
            _context2.next = 3;
            return this.send(request);
          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", near_api_js_1.transactions.SignedTransaction.decode(Buffer.from(response.transaction, 'hex')));
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
  };
  this.signAllTransactions = function (txs) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var request, response, parsed;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            request = {
              transactions: txs.map(function (tx) {
                return Buffer.from(tx.encode()).toString('hex');
              }),
              network: types_1.NETWORK.NEAR,
              type: AppMessages_1.AppMessageTypes.SignAllTransactions
            };
            _context3.next = 3;
            return this.send(request);
          case 3:
            response = _context3.sent;
            parsed = response.transactions.map(function (tx) {
              return near_api_js_1.transactions.SignedTransaction.decode(Buffer.from(tx, 'hex'));
            });
            return _context3.abrupt("return", parsed);
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
  };
  this.signMessage = function (message) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var request, response;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            request = {
              message: message,
              network: types_1.NETWORK.NEAR,
              type: AppMessages_1.AppMessageTypes.SignMessage
            };
            _context4.next = 3;
            return this.send(request);
          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", Uint8Array.from(Buffer.from(response.signature, 'hex')));
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
  };
  this.ws = ws;
  this.timeout = timeout;
});
exports.AppNear = AppNear;
_a = AppNear;
AppNear.build = function (_ref) {
  var appMetadata = _ref.appMetadata,
    url = _ref.url,
    onUserConnect = _ref.onUserConnect,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? 40 * 1000 : _ref$timeout;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", new Promise(function (resolve, reject) {
            var persistent = typeof appMetadata.persistent === 'undefined' ? true : appMetadata.persistent;
            var ws = url ? new isomorphic_ws_1.default(url) : new isomorphic_ws_1.default('wss://relay.nightly.app/app');
            var connection = new AppNear(ws, timeout);
            connection.events[ServerMessage_1.ServerMessageTypes.UserConnected] = function (data) {
              var parsedMeta = JSON.parse(data.metadata);
              var pk = utils_1.PublicKey.fromString(bs58_1.default.encode(Buffer.from(data.publicKey, 'hex')));
              onUserConnect({
                accountId: parsedMeta.accountId,
                publicKey: pk
              });
            };
            connection.ws.onopen = function () {
              var _b;
              connection.ws.onmessage = function (_ref2) {
                var data = _ref2.data;
                var response = JSON.parse(data);
                connection.events[response.id](response);
              };
              var persistentSessionId = persistent ? (_b = localStorage.getItem(sessionIdKey)) !== null && _b !== void 0 ? _b : undefined : undefined;
              var request = (0, AppMessages_1.createInitAction)(Object.assign(Object.assign({}, appMetadata), {
                network: types_1.NETWORK.NEAR,
                persistentSessionId: persistentSessionId
              }));
              // Set up the timeout
              var timer = setTimeout(function () {
                reject(new Error("Connection timed out after ".concat(connection.timeout, " ms")));
              }, timeout);
              connection.events[request.id] = function (response) {
                clearTimeout(timer);
                if (response.type === ServerMessage_1.ServerMessageTypes.InitSuccess) {
                  connection.sessionId = response.sessionId;
                  if (persistent) localStorage.setItem(sessionIdKey, response.sessionId);
                  resolve(connection);
                } else {
                  reject();
                }
              };
              connection.ws.send(JSON.stringify(request));
            };
          }));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
};